import gql from 'graphql-tag';

const updateMarketFactorMutation = gql`
  mutation updateMarketFactor($input: UpdateMarketFactorInput!) {
    updateMarketFactor(input: $input) {
      success
      errors
    }
  }
`;

export default updateMarketFactorMutation;
